import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";
import sub_haz_lev from "../img/sswpIcons/Substances/sub_haz_lev.png";
import sub_no_eat from "../img/sswpIcons/Substances/sub_no_eat.png";
import sub_dat_she from "../img/sswpIcons/Substances/sub_saf_dat.png";
import sub_sto_lab from "../img/sswpIcons/Substances/sub_sto_lab.png";
import sub_was_han from "../img/sswpIcons/Substances/sub_was_han.png";
import sub_ris_ass from "../img/sswpIcons/Substances/sub_ris_ass.png";
import sub_lit from "../img/sswpIcons/Substances/sub_lit.png";
import sub_cov_cut from "../img/sswpIcons/Substances/sub_cov_cut.png";
import sub_per_to_wor from "../img/sswpIcons/Substances/sub_per_to_wor.png";
import sub_sec_sto from "../img/sswpIcons/Substances/sub_sec_sto.png";
import sub_sit_spe_met from "../img/sswpIcons/Substances/sub_sit_spe_met.png";
import sub_spr from "../img/sswpIcons/Substances/sub_spr.png";
import sub_ven from "../img/sswpIcons/Substances/sub_ven.png";

const json = {
    icon: sub_haz_lev,
    name: "Substances",
    text: "",
    icons: {
        sub_sto_lab: {
            name: "Labels",
            icon: sub_sto_lab,
            text: (
                <ul>
                    <ListItem text="Any substance or agent used must have a Safety Data Sheet that is read, understood and followed by the operative" />
                    <Li>
                        <Typography variant="title">
                            {" "}
                            The contents will include
                        </Typography>
                        <ol>
                            <ListItem text="Identification of the substance" />
                            <ListItem text="Hazard identification" />
                            <ListItem text="Ingredients" />
                            <ListItem text="First Aid Measures" />
                            <ListItem text="Fire-fighting measures" />
                            <ListItem text="Accidental release measures" />
                            <ListItem text="Handling and storage" />
                            <ListItem text="Exposure controls/ personal protection" />
                            <ListItem text="Physical and chemical properties" />
                            <ListItem text="Stability and reactivity" />
                            <ListItem text="Toxicological information" />
                            <ListItem text="Ecological information" />
                            <ListItem text="Disposal considerations" />
                            <ListItem text="Transport information" />
                            <ListItem text="Regulatory information" />
                            <ListItem text="Other information" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        sub_saf_dat: {
            name: "Safety Data Sheet",
            icon: sub_dat_she,
            text: (
                <ul>
                    <ListItem text="You must have a copy of the SDS sheet available to you on site for any substance/chemical that you are using. You must be aware and familiar with the information it contains before you use the substance/chemical." />
                    <Li>
                        <Typography variant="title">
                            In particular, be familiar with the following
                            sections
                        </Typography>
                        <ol>
                            <ListItem text="Hazard Identification" />
                            <ListItem text="First Aid Measures" />
                            <ListItem text="Fire-fighting measures" />
                            <ListItem text="Accidental release measures" />
                            <ListItem text="Handling & Storage" />
                            <ListItem text="Exposure controls/ personal protection" />
                            <ListItem text="(Any flash points/ boiling points)" />
                            <ListItem text=" Disposal considerations" />
                            <ListItem text="Transport information" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        sub_sec_sto: {
            name: "Secure Storage/ Approved Containers",
            icon: sub_sec_sto,
            text: (
                <ul>
                    <ListItem text="All chemicals and substances must have a Safety Data Sheet, and you must store materials in accordance with those requirements. This includes storage security and approved container types." />
                    <ListItem text="If transferring chemicals from one container to another, both containers must be of the correct type and labelled correctly with contents. This ensures the next person picking up the container is fully aware of what it contains. Containers should not be left unlabeled, lying around or exposed to sun/weather." />
                </ul>
            )
        },
        sub_ris_ass: {
            name: "Risk Assess/ Plan Safe Method",
            icon: sub_ris_ass,
            text: (
                <ul>
                    <ListItem text="Every work activity needs to be risk assessed prior to commencing. Identify potential hazards. Assess the likelihood of something happening, and the severity if something did go wrong. Select appropriate controls that will be put in place before the activity begins." />
                </ul>
            )
        },
        sub_cov_cut: {
            name: "Cover Cuts",
            icon: sub_cov_cut,
            text: (
                <ul>
                    <ListItem text=" Any operative with open cuts must cover them with waterproof bandages/ dressing prior to commencing work. This is additional to wearing gloves etc." />
                    <ListItem text=" Hands must be thoroughly washed prior to replacing or removing any bandages/ dressings." />
                </ul>
            )
        },
        sub_no_eat: {
            name: "No Eating",
            icon: sub_no_eat,
            text: (
                <ul>
                    <ListItem text="Where work activities expose operatives to risks involving chemical, biological, bacterial or viral risks, operatives should only eat or drink after thoroughly cleaning their hands during break periods. They should not eat, drink or smoke during work activities." />
                </ul>
            )
        },

        sub_ven: {
            name: "Ventilation",
            icon: sub_ven,
            text: (
                <ul>
                    <ListItem text="This control is where an engineered ventilation system is provided" />
                    <Li>
                        <Typography variant="title">
                            This can be of 2 types{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Negative Pressure Enclosures. This involves the building of an enclosure to contain the substance, gas, agent. Negative pressure units are installed within the enclosure to ensure all air flows into the enclosure, and that contained air cannot escape. It is often used for asbestos." />
                            <ListItem text="Local Exhaust Ventilation (LEV). This is an engineered system that captures harmful substances locally, at the emission point. It is often used for fumes, dust, spray." />
                        </ol>
                    </Li>
                    <ListItem text="The system needs to be installed by a competent person and certify that it is fit for purpose and for the intended emissions. It will require a thorough examination at least every 14 months, or shorter if specified by manufacturer." />
                    <ListItem text=" Negative Pressure enclosures must be operated to a strict and site specific method statement. They require a permit to enter system. Workers will have to undergo a decontamination procedure on leaving the enclosure." />
                    <ListItem text="Where LEVs are provided, they must be used by workers. The hood must be large enough, and the extraction air flow strong enough, to capture the emission. LEV hoods must be positioned by the worker to entrain/contain the emission at source. They should have an airflow meter that indicates correct operation. This must be checked by the worker before beginning the task. As a rule, at one ducting diameter distance from the opening, the air flow will be reduced to 10% of the total volume." />
                    <ListItem text="Workers must be clear on the limitation of LEVs and the requirement for other risk controls selected, including breathing PPE." />
                    <ListItem text="For Large system LEVs (where workers are within a ventilation zone), work should be organised such that the worker’s body, or other solid objects, are NOT placed in the air flow path, as this will obstruct flow and generate dead areas." />
                    <ListItem text="The ducting for both systems needs regular visual inspection, for damage, denting, couplings, or leaks. Filters should also be inspected regularly and replaced/cleaned in accordance with the manufacturer instructions." />
                </ul>
            )
        },
        sub_spr: {
            name: "Spraying",
            icon: sub_spr,
            text: (
                <ul>
                    <ListItem text="All substances must have an SDS sheet, and the instructions contained therein must be followed." />
                    <ListItem text="Pesticides and Herbicides should be securely stored in a place capable of being locked. They can only be disposed of using the method outlined in the SDS sheet." />
                    <ListItem text="You should NOT reuse pesticide/herbicide containers." />
                    <ListItem text="Do not eat, drink or smoke while using pesticides and herbicides. Food must be kept away from the area and should be stored in tightly closed boxes." />
                    <ListItem text=" Use suitable equipment for measuring, mixing and transferring. This activity should take place in a well-ventilated area." />
                    <ListItem text="Never expose your bare skin to substances. Never use your mouth to blow and clear blockages. Wash your hands and face with soap and water each time the pump has been refilled, and before eating and drinking. Take a shower/bath at the end of your shift." />
                    <ListItem text=" Leaking equipment must not be used." />
                    <ListItem text="Other persons and animals must be kept away from the spraying area. The spraying discharge should be directed away from the body and take account of wind direction." />
                    <ListItem text="In the case of accidental exposure follow the directions on the SDS sheet. This will generally require access to a reliable supply of water." />
                    <ListItem text="You should wear overalls with long sleeves and trousers and impermeable gloves and footwear. As a minimum your mouth and nose should be covered with a disposable mask. This should be replaced if it becomes wet. The clothing should be kept adequately clean. While mixing you should wear eye protection/face protection, your mouth and nose should be covered, wear impermeable gloves, and an apron." />
                    <ListItem text="Protective clothing should be in good condition (without tears) and washed separately from other clothing. After use, gloves should be washed before they are taken off. At the end of the shift gloves (not disposed of) should be washed inside and outside." />
                </ul>
            )
        },
        sub_lit: {
            name: "Litter Picker",
            icon: sub_lit,
            text: (
                <ul>
                    <ListItem text="Work in teams or use lone working controls." />
                    <ListItem text="Use proper manual handling techniques." />
                    <ListItem text="Any cuts must be covered by waterproof plaster, even if wearing gloves." />
                    <ListItem text="Wear high visibility vests." />
                    <ListItem text="Long grabs devices should be used along with bags. Never touch litter with your hands." />
                    <ListItem text="If syringes are a risk designated containers for disposal must be provided." />
                    <ListItem text="Unidentified cans or canisters, oil drums, poisons, insecticides, clinical waste, broken glass, condoms, or other hazardous waste should be kept separate from other waste items." />
                </ul>
            )
        },
        sub_per_to_wor: {
            name: "Permit To Work",
            icon: sub_per_to_wor,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        },
        sub_was_han: {
            name: "Wash Hands",
            icon: sub_was_han,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            You should wash your hands{" "}
                        </Typography>
                        <ul>
                            <ListItem text="At the end of your shift (or during shift if your hands become heavily soiled)" />
                            <ListItem text="before eating or preparing food, even snacks or drinking fluids" />
                            <ListItem text="After using the toilet" />
                            <ListItem text="After handling rubbish" />
                            <ListItem text="After handling animals" />
                        </ul>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            To wash your hands properly
                        </Typography>
                        <ul>
                            <ListItem text="Wet your hands with clean, running water, turn off the tap" />
                            <ListItem text="Apply soap and lather well for 20 seconds (or longer if dirt is ingrained)" />
                            <ListItem text="Rub hands together rapidly across all surfaces of your hands and wrists. Don’t forget the back of your hands, or ensure you remove rings to wash under them." />
                            <ListItem text="Rinse well under running water and make sure all soap is removed" />
                            <ListItem text="Dry your hands with a clean towel or air dry them. Best results come from using paper towels/single use towels" />
                            <ListItem
                                text="Wash and dry under any rings, to prevent cross contamination.
"
                            />
                        </ul>
                    </Li>
                </ul>
            )
        },
        sub_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: sub_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
